import apolloClient from "../../../apolloClient"
import { LIFELONG_LEARNING_OPERATIONS } from "./operations"

// Education writes stay on api-v3. The Membership reads are live, so refetching
// the mounted ones shows the new status right away. Only call this where the
// screen that made the write stays mounted: screens reached by a redirect fetch
// on mount, and full page redirects discard the result. With the flag off no
// Membership Education query is mounted, so this does nothing.
export const refetchLifelongLearning = async (client = apolloClient) => {
  try {
    await client.refetchQueries({
      include: "active",
      onQueryUpdated: observableQuery =>
        LIFELONG_LEARNING_OPERATIONS.includes(observableQuery.queryName)
          ? observableQuery.refetch()
          : false,
    })
  } catch (error) {
    console.log("error refetching lifelong learning:", error.message)
  }
}
